import React, { useState } from 'react';
import { Helmet } from 'react-helmet';


const FaqSection = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const accordionData = [
    {
      question: "What types of office partitions do you provide?",
      answer: "Anjali Enterprises specializes in all types of aluminium glass office partitions. We offer customized solutions to meet your office space requirements."
    },
    {
      question: "Do you provide toughened glass work?",
      answer: "Yes, we offer all types of toughened glass work for both commercial and residential properties. Our toughened glass is durable and reliable for long-term use."
    },
    {
      question: "What are the benefits of ACP cladding panels?",
      answer: "ACP (Aluminium Composite Panels) are known for their durability, low maintenance, and aesthetic appeal. They are commonly used for building facades and installations."
    },
    {
      question: "Do you install aluminium glass windows?",
      answer: "Yes, we provide installation of aluminium glass windows which are lightweight, durable, and offer excellent insulation properties."
    },
    {
      question: "Can you install soundproof glass windows?",
      answer: "Absolutely! We install soundproof glass windows to reduce noise pollution, making your environment quieter and more comfortable."
    },
    {
      question: "What is the purpose of aluminium mosquito net installation?",
      answer: "Our aluminium mosquito nets are perfect for keeping insects out while maintaining air circulation. These nets are durable and long-lasting."
    },
    {
      question: "Do you provide bird net installation services?",
      answer: "Yes, we provide bird net installation to protect your buildings from bird-related issues and to keep your premises clean and safe."
    },
    {
      question: "What are invisible grill installations used for?",
      answer: "Invisible grills are used for securing windows and balconies while maintaining an aesthetic appearance. They are strong yet barely visible, ensuring both safety and beauty."
    },
    {
      question: "Do you offer MS fabrication work?",
      answer: "We offer a wide range of MS (Mild Steel) fabrication services, including doors, shades, grills, slide doors, and industrial shades, tailored to meet your specific needs."
    },
  ];

  return (


    <div>


<Helmet>
  <title>Contact: +91 8793220265 | Anjali Enterprises | Aluminium Glass Office Partition Services</title>
  <meta name="description" content="Anjali Enterprises provides all types of Aluminium Glass Office Partition solutions in Pune, including office glass partition installation, room dividers, and premium soundproof partitions. Call +91 8793220265 for more details." />
  <meta name="keywords" content="Aluminium Glass Partition, Office Glass Partition Installation, Glass Partition for Offices in Pune, Office Room Divider Glass, Aluminium Partitioning for Offices, Partitioning Solutions, Best Office Partitions in Pune, Aluminium Framed Glass Office Partition, Modern Office Partitions, Partition Wall Installation, Pune Office Glass Partition Service, Glass Partition Work in Pune, Premium Office Partitions, Soundproof Glass Partitions, Glass Partition Contractors Pune" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8793220265 | Anjali Enterprises | Aluminium Glass Office Partition Services" />
  <meta property="og:description" content="Anjali Enterprises provides all types of Aluminium Glass Office Partition solutions in Pune, including office glass partition installation, room dividers, and premium soundproof partitions. Call +91 8793220265 for more details." />
  <meta property="og:image" content="https://anjalienterprisesindia.com/images/office-partition-service.jpg" />
  <meta property="og:url" content="https://anjalienterprisesindia.com/aluminium-glass-office-partition" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="Anjali Enterprises" />

  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "Anjali Enterprises",
        "description": "Anjali Enterprises provides all types of Aluminium Glass Office Partition solutions in Pune, including office glass partition installation, room dividers, and premium soundproof partitions. Call +91 8793220265 for more details.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411057",
          "addressCountry": "IN"
        },
        "telephone": "+91-8793220265",
        "email": "info@anjalienterprisesindia.com",
        "url": "https://anjalienterprisesindia.com/aluminium-glass-office-partition",
        "logo": "https://anjalienterprisesindia.com/images/anjali-enterprises-logo.jpg",
        "image": "https://anjalienterprisesindia.com/images/office-partition-service.jpg",
        "priceRange": "₹1000 - ₹10000",
        "offers": {
          "@type": "Offer",
          "url": "https://anjalienterprisesindia.com/aluminium-glass-office-partition",
          "priceCurrency": "INR",
          "price": "1000",
          "priceValidUntil": "2025-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.7",
          "reviewCount": "45"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Rajesh T"
            },
            "datePublished": "2024-08-10",
            "reviewBody": "Anjali Enterprises did an excellent job with our office partition. The glass partition installation was smooth, and the final result looks amazing. Highly recommended!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Sanya M"
            },
            "datePublished": "2024-09-18",
            "reviewBody": "I am very pleased with the soundproof glass partitions they installed in our office. The quality and finishing are top-notch."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Anjali Enterprises Service Area",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5195",
            "longitude": "73.8551"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://anjalienterprisesindia.com/aluminium-glass-office-partition"
        },
        "keywords": "Aluminium Glass Partition, Office Glass Partition Installation, Glass Partition for Offices in Pune, Office Room Divider Glass, Aluminium Partitioning for Offices, Partitioning Solutions, Best Office Partitions in Pune, Aluminium Framed Glass Office Partition, Modern Office Partitions, Partition Wall Installation, Pune Office Glass Partition Service, Glass Partition Work in Pune, Premium Office Partitions, Soundproof Glass Partitions, Glass Partition Contractors Pune"
      }
    `}
  </script>
</Helmet>
      {/* Banner */}
      <div className="inner-pages-bnr">
        <img src="images/service-banner.jpg" className="img-responsive" alt="Service-banner-image" />
        <div className="banner-caption">
          <h1>Faqs</h1>
        </div>
      </div>

      <section className="pad95-100-top-bottom">
        <div className="container">
          <h3 className="marbtm30">Frequently Asked Questions</h3>
          <p className="fnt-18 marbtm50">
            At Anjali Enterprises, we specialize in providing a wide range of solutions for your construction, renovation, and office requirements. Below are some of the most frequently asked questions about our services.
          </p>
          <div className="row">
            {/* Faq Left Column */}
            <div className="col-md-8 col-sm-7 col-xs-12 faq-mobile-margin">
              <div className="accordion-first accordion-second clearfix acord_mar_non">
                <div className="accordion" id="accordion2">
                  {accordionData.map((item, index) => (
                    <div className="accordion-group" key={index}>
                      <div className="accordion-heading">
                        <button
                          className="accordion-toggle"
                          onClick={() => toggleAccordion(index)}
                          aria-expanded={activeIndex === index ? 'true' : 'false'}
                        >
                          <em className={`icon-fixed-width fa ${activeIndex === index ? 'fa-minus' : 'fa-plus'}`}></em>
                          {item.question}
                        </button>
                      </div>
                      <div className={`accordion-body ${activeIndex === index ? 'collapse show' : 'collapse'}`}>
                        <div className="accordion-inner">
                          <p>{item.answer}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Faq Right Column */}
            <div className="col-md-4 left-column pull-right">
              <div className="wdt-100 marbtm50">
                <h3 className="marbtm30">Need Support?</h3>
                <p className="fnt-17">
                  Our team is always ready to assist you with any inquiries. We provide personalized consultations to understand your needs better and offer expert solutions.
                </p>
              </div>
              <div className="contact-help">
                <h4>Contact us for help?</h4>
                <p className="fnt-17">
                  Reach out to our representative for guidance or submit your business inquiry through our online form.
                </p>
              </div>
              {/* <a className="pdf-button" href="#">DOWNLOAD BROCHURE</a> */}
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default FaqSection;
